import { DashboardFormType } from '@organisms/GenesisEs/Forms/DashboardFormType';
import { Storage } from '@states/Storage';


const Open = (defaultParams: any) => {
    const searchParams: any = Object.assign({}, defaultParams);
    const formData: DashboardFormType = Storage.get(Storage.keys.GENESISES_DASHBOARD);
    searchParams.relitRequestDate = formData.date;
    searchParams.timestamp = formData.timestamp;
    return searchParams;
};
const Close = (defaultParams: any) => {
    const searchParams: any = Object.assign({}, defaultParams);
    const formData: DashboardFormType = Storage.get(Storage.keys.GENESISES_DASHBOARD);
    searchParams.abolitionRequestDate = formData.date;
    searchParams.timestamp = formData.timestamp;
    return searchParams;
};

const CreateSearchParams = {
    Open,
    Close
};

export default CreateSearchParams;